import React from "react";
import docs from "../images/docs.png";
import drive from "../images/drive.png";
import gmail from "../images/gmail.png";
import github from "../images/github.png";
import moodle from "../images/moodle.png";
import swarthmore from "../images/Swarthmore.png";
import thedash from "../images/thedash.png";

function Shortcuts() {
  return (
    <div className="links shortcuts-2">
        <h3>Quick Links</h3>
        <div className="productivity-links">
            <a className="link" href="https://docs.google.com/document/u/0/?tgif=d" rel="noopener noreferrer" target="_blank"><img alt="google docs icon" src={docs}/></a>
            <a className="link" href="https://drive.google.com/drive/u/0/" rel="noopener noreferrer" target="_blank"><img alt="google drive icon" src={drive}/></a>
            <a className="link" href="https://gmail.google.com" rel="noopener noreferrer" target="_blank"><img alt="gmail icon" src={gmail}/></a>
            <a className="link" href="https://github.com" rel="noopener noreferrer" target="_blank"><img alt="github icon"src={github}/></a>
        </div>
        <div className="school-links">
            <a className="link" href="http://moodle.swarthmore.edu" rel="noopener noreferrer" target="_blank"><img alt="moodle icon" src={moodle}/></a>
            <a className="link" href="http://myswat.swarthmore.edu" rel="noopener noreferrer" target="_blank"><img width="45" height="45" alt="myswat icon" src={swarthmore}/></a>
            <a className="link" href="https://dash.swarthmore.edu" rel="noopener noreferrer" target="_blank"><img height="50" alt="the dash icon" src={thedash}/></a>
        </div>
    </div>
  );
}

export default Shortcuts;